import React, { Dispatch, FC, SetStateAction } from 'react';
import { InputArea, FormField, Text } from '@wix/design-system';
import { StatusIndicatorState } from '@wix/design-system/dist/types/StatusIndicator';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { InputStatus } from '@wix/design-system/dist/types/Input/Input.types';

export type ReviewTextAreaProps = {
  textLabel: string;
  textPlaceholder?: string;
  reviewText: string;
  reviewTextStatus: StatusIndicatorState | undefined;
  isReviewTextChanged: boolean;
  setReviewText: Dispatch<SetStateAction<string>>;
  setReviewTextError: Dispatch<
    SetStateAction<StatusIndicatorState | undefined>
  >;
  setIsReviewTextChanged: Dispatch<SetStateAction<boolean>>;
  enableAutoFocus?: boolean;
};

const ReviewTextArea: FC<ReviewTextAreaProps> = ({
  textLabel,
  textPlaceholder,
  reviewText,
  reviewTextStatus,
  isReviewTextChanged,
  setReviewText,
  setReviewTextError,
  setIsReviewTextChanged,
  enableAutoFocus,
}) => {
  const { t } = useTranslation();

  return (
    <FormField
      required
      label={
        <Text size="small" weight="thin">
          {textLabel}
        </Text>
      }
    >
      <InputArea
        autoFocus={enableAutoFocus}
        dataHook="review-modal-text"
        minHeight="146px"
        value={reviewText}
        onChange={(e: any) => {
          setReviewText(e.target.value);
          setIsReviewTextChanged(true);
          setReviewTextError(undefined);
        }}
        onBlur={() => {
          isReviewTextChanged && !reviewText && setReviewTextError('error');
        }}
        placeholder={textPlaceholder ? textPlaceholder : ''}
        status={reviewTextStatus as InputStatus}
        statusMessage={t('marketplace.template-page.review-modal.text-error')}
        maxLength={500}
        hasCounter
      />
    </FormField>
  );
};

export default ReviewTextArea;
